import styled from 'styled-components';

export const Wrapper = styled.div`
  position: absolute;
  top: -45px;
  right: -60px;
`;

export const Curve = styled.div`
  border: ${({ theme }) => `4px solid ${theme.palette.backgrounds.arrow}`};
  border-color: ${({ theme }) =>
    `transparent ${theme.palette.backgrounds.arrow} transparent transparent`};
  height: 220px;
  width: 200px;
  border-radius: 0 230px 150px 0;
`;

export const Point = styled.div`
  &::before {
    top: 169px;
    right: 26px;
    transform: rotate(-5deg);

    border: ${({ theme }) => `1px solid ${theme.palette.backgrounds.arrow}`};
    height: 25px;
    content: '';
    position: absolute;
  }

  &::after {
    top: 176px;
    right: 11px;
    transform: rotate(72deg);

    border: ${({ theme }) => `1px solid ${theme.palette.backgrounds.arrow}`};
    height: 25px;
    content: '';
    position: absolute;
  }
`;
